import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Download } from 'lucide-react';
import { generateDashboardPDF } from '@/utils/pdfExport';

const CHECK_NAMES = {
  'address_check': 'Address',
  'criminal_court_check': 'Criminal Court',
  'id_check': 'ID Check',
  'employment_check': 'Employment',
  'education_check': 'Education',
  'credit_check': 'Credit',
  'personal_reference': 'Personal Ref',
  'professional_reference': 'Professional Ref',
  'world_criminal_db': 'World Criminal',
  'india_criminal_db': 'India Criminal',
  'drug_test': 'Drug Test'
};

export default function AnalyticsTab({ stats, analytics }) {
  return (
    <div data-testid="analytics-tab">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold text-slate-900">Analytics</h1>
        <Button variant="outline" onClick={() => generateDashboardPDF(stats, analytics)}>
          <Download className="w-4 h-4 mr-2" />Export Report
        </Button>
      </div>
      <div className="grid grid-cols-4 gap-4 mb-6">
        <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
          <CardContent className="pt-6">
            <div className="text-center">
              <p className="text-3xl font-bold text-blue-700">{stats?.total_cases || 0}</p>
              <p className="text-sm text-blue-600">Total Cases</p>
            </div>
          </CardContent>
        </Card>
        <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
          <CardContent className="pt-6">
            <div className="text-center">
              <p className="text-3xl font-bold text-green-700">{stats?.completed_cases || 0}</p>
              <p className="text-sm text-green-600">Completed</p>
            </div>
          </CardContent>
        </Card>
        <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200">
          <CardContent className="pt-6">
            <div className="text-center">
              <p className="text-3xl font-bold text-amber-700">{stats?.pending_cases || 0}</p>
              <p className="text-sm text-amber-600">Pending</p>
            </div>
          </CardContent>
        </Card>
        <Card className="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200">
          <CardContent className="pt-6">
            <div className="text-center">
              <p className="text-3xl font-bold text-purple-700">{analytics?.check_stats ? Object.keys(analytics.check_stats).length : 0}</p>
              <p className="text-sm text-purple-600">Check Types</p>
            </div>
          </CardContent>
        </Card>
      </div>
      {analytics?.check_stats && (
        <Card>
          <CardHeader><CardTitle>Check Type Performance</CardTitle></CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Check Type</TableHead>
                  <TableHead>Total</TableHead>
                  <TableHead>Completed</TableHead>
                  <TableHead>Pending</TableHead>
                  <TableHead>Completion Rate</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {Object.entries(analytics.check_stats).map(([type, data]) => (
                  <TableRow key={type}>
                    <TableCell className="font-medium">{CHECK_NAMES[type] || type}</TableCell>
                    <TableCell>{data.total}</TableCell>
                    <TableCell className="text-green-600">{data.completed}</TableCell>
                    <TableCell className="text-amber-600">{data.pending}</TableCell>
                    <TableCell>
                      <Badge className={data.total > 0 && (data.completed / data.total) > 0.7 ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}>
                        {data.total > 0 ? Math.round((data.completed / data.total) * 100) : 0}%
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
